var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.33333C5.82319 3.33333 5.65362 3.40357 5.5286 3.5286C5.40357 3.65362 5.33333 3.82319 5.33333 4L5.33333 12.1559L7.657 10.7617C7.86812 10.635 8.13188 10.635 8.343 10.7617L10.6667 12.1559V4C10.6667 3.82319 10.5964 3.65362 10.4714 3.5286C10.3464 3.40357 10.1768 3.33333 10 3.33333L6 3.33333ZM4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2L10 2C10.5304 2 11.0391 2.21071 11.4142 2.58579C11.7893 2.96086 12 3.46957 12 4L12 13.3333C12 13.5735 11.8708 13.7951 11.6618 13.9135C11.4528 14.0318 11.1963 14.0286 10.9903 13.905L8 12.1108L5.00966 13.905C4.80371 14.0286 4.54721 14.0318 4.3382 13.9135C4.1292 13.7951 4 13.5735 4 13.3333L4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.9ce29afc4e9b66478cfa4a2c35791d81.svg";
export { ForwardRef as ReactComponent };